import React, { useEffect, useState } from "react";
import { conciergeAuthFetch } from "../../../../utils/conciergeCmsAuth";

const UPLOAD_BASE_URL = "https://wizmarket.ai/uploads/";

function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat("ko-KR", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
  } catch {
    return iso;
  }
}

export default function ConciergeUserHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        setError("");
        const res = await conciergeAuthFetch("/concierge/user/history?page=1&limit=50");
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.detail || "히스토리를 불러오지 못했습니다.");
        setItems(data.items || []);
      } catch (err) {
        setError(err.message || "히스토리를 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  return (
    <div className="px-8 py-8">
      <h1 className="text-2xl font-bold text-[#111827]">컨시어지 히스토리</h1>
      <div className="mt-6 overflow-hidden rounded-2xl border border-[#ebeef5] bg-white">
        {loading ? (
          <div className="px-6 py-10 text-sm text-[#6b7280]">로딩 중입니다...</div>
        ) : error ? (
          <div className="px-6 py-10 text-sm text-red-500">{error}</div>
        ) : items.length === 0 ? (
          <div className="px-6 py-10 text-sm text-[#6b7280]">히스토리가 없습니다.</div>
        ) : (
          <table className="min-w-full text-sm">
            <thead className="bg-[#f8fafc] text-[#6b7280]">
              <tr>
                <th className="px-4 py-3 text-left">생성일</th>
                <th className="px-4 py-3 text-left">매장명</th>
                <th className="px-4 py-3 text-left">사용 메뉴</th>
                <th className="px-4 py-3 text-left">업로드 상태</th>
                <th className="px-4 py-3 text-left">이미지</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#eef2f7]">
              {items.map((item) => (
                <tr key={item.id}>
                  <td className="px-4 py-4">{formatDateTime(item.created_at)}</td>
                  <td className="px-4 py-4">{item.store_name || "-"}</td>
                  <td className="px-4 py-4">{item.register_tag || "-"}</td>
                  <td className="px-4 py-4">{item.insta_status || item.status || "-"}</td>
                  <td className="px-4 py-4">
                    {item.image_path ? (
                      <img
                        src={`${UPLOAD_BASE_URL}${item.image_path}`}
                        alt={item.register_tag || item.store_name || "history"}
                        className="h-20 w-20 rounded-lg object-cover"
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

